import { Backdrop, Button, CardContent, CircularProgress, Container, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, List, ListItem, ListItemText, Paper, Radio, RadioGroup, Select, Step, StepContent, StepLabel, Stepper, TextField, Typography } from '@material-ui/core';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import AttachmentIcon from '@material-ui/icons/Attachment';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ImQrcode } from "react-icons/im";
import Alert from 'src/components/Alert';
import FilesPreview from 'src/components/FilePreview';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser, safeParseInt } from 'src/utils/Common';
import { loadFotograf } from 'src/utils/storage/StrPhoto';
import BarkodPopup from '../../components/BarcodePopup';
import CamPopup from '../../components/CamPopup';
import FilePopup from '../../components/FilePopup';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  submitButtonScrap: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  dividerScrap: {
    backgroundColor: '#FF9800'
  },
  formControl: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));

const ProductChangeScrapFileTypes = [
  { value: 26, label: 'Ürün Değişim Kabul Fotoğrafı' },
  { value: 19, label: 'Ürün Ambalaj Fotoğrafları' }
]

const ProductChangeScrap = () => {
  const classes = useStyles();
  const SessionUser = getUser();
  const [Loading, setLoading] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [openBarkodScrap, setOpenBarkodScrap] = useState(false);
  const [BarkodScrap, setBarkodScrap] = useState([]);
  const [FisNoScrap, setFisNoScrap] = useState(0);
  const [openCam, setOpenCam] = useState(false);
  const [files, setFiles] = useState([]);
  const [openFile, setOpenFile] = useState(false);
  const [Hasarvalue, setHasarvalue] = React.useState(null);
  const [Ambalajvalue, setAmbalajvalue] = React.useState(null);
  const [EksikMalzemeAksesuarvalue, setEksikMalzemeAksesuarvalue] = React.useState(null);
  const [EksikNotlar, setEksikNotlar] = React.useState("");
  const [AmbalajKontrol, setAmbalajKontrol] = React.useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [AmbalajUyari, setAmbalajUyari] = React.useState(null);
  const [productChangeScrapFileType, setProductChangeScrapFileType] = useState(26);
  const steps = getSteps();
  function getSteps() {
    return ['Ürün Bilgileri', 'Ürün Fotoğrafları', 'Kontrol', 'Fotoğraf Ekle', 'Sonlandır'];
  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  useEffect(() => {
    let mounted = true;
    // setLoading(true);
    if (FisNoScrap !== 0) {
      axios.get('/GetArtemisAmbalajUyari/' + FisNoScrap).then((response) => {
        response.data.map(item => setAmbalajUyari(item.UYARI))
      });
    }
    fetchPhotos(mounted);
    return () => {
      mounted = false;
    };

    // eslint-disable-next-line
  }, [FisNoScrap]);
  const fetchPhotos = (mounted) => {
    setLoading(true);
    const localPhotos = loadFotograf(FisNoScrap);
    setFiles(localPhotos);
    axios.get('/GetArtemisDosyaListe/' + FisNoScrap).then((response) => {
      if (mounted) {
        if (response.data === "") {
          setFiles(localPhotos);
          setLoading(false);
        } else {
          const Deger = response.data;
          setFiles([...Deger, ...localPhotos]);
          setLoading(false);
        }
      }
    }).catch(error => {
      setFiles(localPhotos);
      setLoading(false);
            logger.error("Hata detayı:", error.message);
    });
  };
  const handleHasarRadioChange = (event) => {
    setHasarvalue(event.target.value);
  };
  const handleAmbalajRadioChange = (event) => {
    setAmbalajvalue(event.target.value);
  };
  const handleEksikMalzemeAksesuarRadioChange = (event) => {
    setEksikMalzemeAksesuarvalue(event.target.value);
  };
  const handleChangeEksikNotlar = (event) => {
    setEksikNotlar(event.target.value);
  };
  const handleCamOpen = () => {
    setOpenCam(true);
  }
  const handleCamClose = (type) => {
    if (type === 'file') {
      setOpenFile(false);
    } else {
      setOpenCam(false);
    }
    setLoading(true);
    const localPhotos = loadFotograf(FisNoScrap);
    setFiles(localPhotos);
    axios.get('/GetArtemisDosyaListe/' + FisNoScrap).then((response) => {
      if (response.data === "") {
        setLoading(false);
        setFiles(localPhotos);
      } else {
        const Deger = response.data;
        setFiles([...Deger, ...localPhotos]);
        setLoading(false);
      }
    }).catch(error => {
      setFiles(localPhotos);
      setLoading(false);
            logger.error("Hata detayı:", error.message);
    });
  }
  const handleFileOpen = () => {
    setOpenFile(true);
  }
  const handleFileClose = () => {
    handleCamClose('file');
  }
  const handleBarkodOpenScrap = () => {
    setUyari(false);
    setOpenBarkodScrap(true);
  }
  const handleBarkodClose = async (barkod) => {
    setOpenBarkodScrap(false);
    if (barkod.length === undefined || barkod === "" || barkod === undefined || barkod === null) {
      setUyari(true);
      setUyariAciklama("Lütfen önce barkod okutunuz!...");
      setUyariTip("error");
      handleReset();
      return;
    }
    const ScrapReturnData = [];
    let ScrapDetailData = barkod.split("\n");
    ScrapReturnData.push({
      Musteri: ScrapDetailData[0] ? ScrapDetailData[0]?.split(":")[1] : 0,
      GPS: ScrapDetailData[1] ? ScrapDetailData[1].split(":")[1] : 0,
      Servis: ScrapDetailData[2] ? ScrapDetailData[2].split(":")[1] : 0,
      UrunGrup: ScrapDetailData[3] ? ScrapDetailData[3].split(":")[1] : 0,
      Urun: ScrapDetailData[4] ? ScrapDetailData[4].split(":")[1] : 0,
      Seri: ScrapDetailData[5] ? ScrapDetailData[5].split(":")[1] : 0,
      FisNo: ScrapDetailData[6] ? ScrapDetailData[6].split(":")[1] : 0,
      Ambalaj: ScrapDetailData[7] ? ScrapDetailData[7].split(":")[1] : "Yok",
    });
    setBarkodScrap(ScrapReturnData);
    setFisNoScrap(ScrapDetailData[6] ? ScrapDetailData[6].split(":")[1] : 0);
    var AmbalajKontrolValue = false;
    if (ScrapDetailData[7] ? ScrapDetailData[7].split(":")[1] : "Yok" === "Var") {
      AmbalajKontrolValue = true;
    }
    setAmbalajKontrol(AmbalajKontrolValue);
  }
  const handleNext = () => {

    if (FisNoScrap === 0 || FisNoScrap === undefined || FisNoScrap === null) {
      setUyari(true);
      setUyariAciklama("Lütfen önce barkod okutunuz!...");
      setUyariTip("error");
      return;
    }
    if (parseInt(activeStep) === 2) {
      if (parseInt(EksikMalzemeAksesuarvalue) === 1) {
        if (EksikNotlar.trim().length === 0) {
          setUyari(true);
          setUyariAciklama("Eksik Aksesuar/Malzeme giriniz!...");
          setUyariTip("error");
          return;
        }
      }

      Ambalajvalue === "0" ? setProductChangeScrapFileType(19) : setProductChangeScrapFileType(26);
    }

    if (parseInt(activeStep) === 3) {
      if (AmbalajUyari && Ambalajvalue === "0" && files.filter(x => x.TIP_ID === 19).length === 0) {
        setUyari(true);
        setUyariAciklama("Lütfen 'Ürün Ambalaj Fotoğrafı' ekleyiniz!...");
        setUyariTip("error");
        return;
      }
    }

    if (parseInt(activeStep) === 4) {
      var Uyari = FisNoScrap + " numaralı fişiniz için tamamlandı yapılacaktır!... Devam etmek istediginizden emin misiniz?";
      confirmAlert({
        message: Uyari,
        buttons: [
          {
            label: 'Evet',
            onClick: () => ScrapAccept(FisNoScrap)
          },
          {
            label: 'Hayır',
            onClick: () => { return; }
          }
        ]
      });
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleReset = () => {
    setActiveStep(0);
    setUyariAciklama("");
    setUyari(false);
    setBarkodScrap([]);
    setFisNoScrap(0);
    setFiles([]);
    setHasarvalue(null);
    setAmbalajvalue(null);
    setEksikMalzemeAksesuarvalue(null);
    setEksikNotlar("");
  };

  const ScrapAccept = (FisNo) => {
    setLoading(true);
    setUyari(false);
    if (Hasarvalue === null || EksikMalzemeAksesuarvalue === null) {
      setUyariTip("error");
      setUyariAciklama("Lütfen 'Kontrol' sekmesindeki tüm soruları yanıtlayınız!");
      setLoading(false);
      setUyari(true);
    }
    else if (Ambalajvalue === null && (AmbalajUyari === true || AmbalajUyari === 1)) {
      setUyariTip("error");
      setUyariAciklama("Lütfen 'Kontrol' sekmesindeki tüm soruları yanıtlayınız!");
      setLoading(false);
      setUyari(true);
    }
    else {
      var dataScrap = []
      if (
        AmbalajUyari === 0 ||
        AmbalajUyari === false ||
        !Number.isInteger(Number(Ambalajvalue))
      ) {
        dataScrap = [{
          Damage: safeParseInt(Hasarvalue),
          Packing: 2,
          MissingAccessoryMaterial: safeParseInt(EksikMalzemeAksesuarvalue),
          ServicePaperNr: safeParseInt(FisNo.replaceAll(" ", "")),
          NoteMissingAccessoryMaterial: EksikNotlar,
          User: SessionUser.UserId,
        }];
      } else {
        dataScrap = [{
          Damage: safeParseInt(Hasarvalue),
          Packing: safeParseInt(Ambalajvalue),
          MissingAccessoryMaterial: safeParseInt(EksikMalzemeAksesuarvalue),
          ServicePaperNr: safeParseInt(FisNo.replaceAll(" ", "")),
          NoteMissingAccessoryMaterial: EksikNotlar,
          User: SessionUser.UserId,
        }];
      }
      const configScrap = {
        headers: { 'Content-Type': 'application/json' }
      }

      axios.post('/SetArtemisProductChangeScrap', dataScrap, configScrap)
        .then(response => {
          if (response.data.toString().length < 5) {
            setUyariTip("success");
            setUyariAciklama("İşleminiz başarı ile gerçekleştirildi...");
            setLoading(false);
            setUyari(true);
            setOpenBarkodScrap(false);
            setBarkodScrap([]);
            setFisNoScrap(0);
            setOpenCam(false);
            setFiles([]);
            setOpenFile(false);
            setHasarvalue(null);
            setAmbalajvalue(null);
            setEksikMalzemeAksesuarvalue(null);
            setEksikNotlar("");
            setAmbalajKontrol(false);
            setActiveStep(0);
            setAmbalajUyari(null);
          } else {
            setUyariTip("error");
            setUyariAciklama(response.data);
            setLoading(false);
            setUyari(true);
          }
        })
        .catch(error => {
          setUyari(true);
          setUyariAciklama(error.response?.data?.error || '');
          setUyariTip("error");
          setLoading(false);
        });

    }
  }
  function getStepContent(step) {
    switch (step) {
      case 0:
        return <List className={classes.root}>
          {BarkodScrap.map(item => (
            <div key={item.FisNo}>
              <ListItem alignItems="flex-start">
                <ListItemText>
                  <Typography variant="body1" gutterBottom>
                    <b>FişNo : </b>
                    {item.FisNo}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <b>Müşteri : </b>
                    {item.Musteri}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <b>Servis : </b>
                    {item.Servis}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <b>GPS : </b>
                    {item.GPS}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <b>Ürün Grubu : </b>
                    {item.UrunGrup}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <b>Ürün : </b>
                    {item.Urun}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <b>Ay-Yıl-Seri: </b>
                    {item.Seri}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <b>Ambalaj Kontrol: </b>
                    {item.Ambalaj}
                  </Typography>
                </ListItemText>
              </ListItem>
            </div>
          ))}
        </List>;
      case 1:
        return <div><FilesPreview FisNo={FisNoScrap} files={files} fetchPhotos={fetchPhotos} setLoading={setLoading} /><br /></div>;
      case 2:
        return <FormControl component="fieldset">
          <FormLabel component="legend">Ürünlerde İlave Hasar Oluşmuş mu ?</FormLabel>
          <RadioGroup row aria-label="position" value={Hasarvalue} onChange={handleHasarRadioChange} name="position" defaultValue="top">
            <FormControlLabel
              value="1"
              control={<Radio color="primary" />}
              label="Evet"
              labelPlacement="Evet"
            />
            <FormControlLabel
              value="0"
              control={<Radio color="secondary" />}
              label="Hayır"
              labelPlacement="Hayır"
            />

          </RadioGroup>
          <br />
          {AmbalajUyari ? <>
            <FormLabel component="legend">Bültene Uygun Şekilde Ambalaj Yapılmış mı?</FormLabel>
            <RadioGroup row aria-label="position" disabled={AmbalajKontrol} name="position" value={Ambalajvalue} onChange={handleAmbalajRadioChange} defaultValue="top">
              <FormControlLabel
                value="1"
                control={<Radio color="primary" />}
                label="Evet"
                labelPlacement="Evet"
              />
              <FormControlLabel
                value="0"
                control={<Radio color="secondary" />}
                label="Hayır"
                labelPlacement="Hayır"
              />
            </RadioGroup>
            <br />
          </>
            : <>{AmbalajKontrol}</>}
          <FormLabel component="legend">Ürünlerde Eksik Malzeme/Aksesuar Var mı ?</FormLabel>
          <RadioGroup row aria-label="position" name="position" value={EksikMalzemeAksesuarvalue} onChange={handleEksikMalzemeAksesuarRadioChange} defaultValue="top">
            <FormControlLabel
              value="1"
              control={<Radio color="primary" />}
              label="Evet"
              labelPlacement="Evet"
            />
            <FormControlLabel
              value="0"
              control={<Radio color="secondary" />}
              label="Hayır"
              labelPlacement="Hayır"
            />
          </RadioGroup>
          <TextField
            label={"Eksik Malzeme/Aksesuar"}
            name="EksikNotlar"
            multiline
            rows={4}
            fullWidth
            value={EksikNotlar}
            onChange={handleChangeEksikNotlar}
            variant="outlined"
            // disabled={readonly}
            inputProps={{ maxLength: 2000 }}
          />
        </FormControl>;
      case 3:
        return <div>
          <Grid container
            justifyContent="space-between"
            alignItems="center" >
            {AmbalajUyari && Ambalajvalue === "0" && files.filter(x => x.TIP_ID === 19).length === 0 ?
              <Grid item xs={12}>
                <Alert
                  message={'"Bültene Uygun Şekilde Ambalaj Yapılmış mı?" sorusuna hayır cevabını verdiniz. Lütfen aşağıdan Ürün Ambaj Fotoğrafı ekleyin. (Fotoğrafı eklediğinizde bu uyarı kaybolacak)'}
                  variant={"warning"}
                />
              </Grid> : <>  </>
            }
            <Grid item xs={2}>
              <IconButton aria-label="settings" onClick={handleCamOpen}>
                <AddAPhotoIcon color="primary"></AddAPhotoIcon>
              </IconButton>
            </Grid>
            <Grid item xs={8}>
              {AmbalajUyari && Ambalajvalue === "0" ?
                <FormControl variant="outlined" className={classes.formControl} >
                  <Select
                    fullWidth
                    native
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={productChangeScrapFileType}
                    onChange={(e) => {
                      setProductChangeScrapFileType(e.target.value);
                    }}
                  >
                    {ProductChangeScrapFileTypes.map((item) => (
                      <option value={item.value}>{item.label}</option>
                    ))}
                  </Select>
                </FormControl> : <></>}
            </Grid>
            <Grid item xs={2} align="right">
              <IconButton aria-label="settings" onClick={handleFileOpen}>
                <AttachmentIcon color="primary"></AttachmentIcon>
              </IconButton>
            </Grid>
          </Grid>
          <CardContent className={classes.content}>
            {
              Loading ?
                <CircularProgress status={'loading'} style={{ marginLeft: '50%' }} />
                : <div></div>
            }
            <div style={{ marginBottom: '10px' }}>
              <FilesPreview FisNo={FisNoScrap} files={files} fetchPhotos={fetchPhotos} setLoading={setLoading} />
            </div>
            {
              uyari ?
                <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama} variant={uyariTip} />
                : <div></div>
            }
          </CardContent>
        </div>
      case 4:
        return "Tüm işlemleri tamamladıysanız Merkeze Gönder seçebilirsiniz!..."
      default:
        return 'Veri Yok';
    }
  }

  return (
    <Page className={classes.root} title='Değişim Eskisi Kabul'>
      <Container maxWidth="lg">
        <div className={classes.root}>
          <br />
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
              <Button
                variant="contained"
                color="secondary"
                className={classes.submitButtonScrap}
                onClick={handleBarkodOpenScrap}
                endIcon={<ImQrcode />}>
                Ürün Kabul(Barkod Okut)
              </Button>
            </Grid>
          </Grid>
          <br />
          {
            Loading ?
              <Backdrop className={classes.backdropScrap} open={Loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
              : <div></div>
          }
          {
            uyari ?
              <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
              : <div></div>
          }
          <Divider className={classes.dividerScrap} />
          <br />
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <Typography>{getStepContent(index)}</Typography>
                  <div className={classes.actionsContainer}>
                    <div>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        color="secondary"
                        variant="contained"
                        startIcon={<NavigateBeforeIcon />}
                        className={classes.button}>
                        Gerİ
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleNext}
                        endIcon={<NavigateNextIcon />}
                        className={classes.button}
                      >
                        {activeStep === steps.length - 1 ? 'Tamamla' : 'İlerİ'}
                      </Button>
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Typography>Bütün İşlemler Tamamlanıp Merkeze Gönderildi!...</Typography>
              <Button
                variant="contained"
                color="secondary"
                className={classes.submitButtonScrap}
                onClick={handleReset}
                endIcon={<RotateLeftIcon />}>
                Başa Dön
              </Button>
            </Paper>
          )}
        </div>
      </Container>
      <BarkodPopup onClose={handleBarkodClose} open={openBarkodScrap} ScanTime={0} CallScreen={0} />
      <CamPopup
        onClose={handleCamClose}
        FisNo={FisNoScrap.toString().replaceAll(" ", "")}
        DosyaTipi={ProductChangeScrapFileTypes?.find(x => x.value === productChangeScrapFileType).value.toString()}
        DosyaTipiText={ProductChangeScrapFileTypes?.find(x => x.value === productChangeScrapFileType).label}
        open={openCam}
      />
      <FilePopup
        onClose={handleFileClose}
        FisNo={FisNoScrap.toString().replaceAll(" ", "")}
        DosyaTipi={ProductChangeScrapFileTypes?.find(x => x.value === productChangeScrapFileType).value.toString()}
        DosyaTipiText={ProductChangeScrapFileTypes?.find(x => x.value === productChangeScrapFileType).label}
        open={openFile}
      />
    </Page>
  );
}


export default ProductChangeScrap;
